import { DefaultProp } from './defaultprop';

/**
 * Pelagem
 */
export class Pelage extends DefaultProp {

    /**
     * Instanciar um
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<Pelage>) {
        super(init);
        Object.assign(this, init);
    }
}
